<template>
    <div>
        <div class="org-tree-layout" name="tree-block">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="includeSubComs" @notity-change="notityChange($event)"></swb-popover-org-tree>
        </div>

        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="configAuto" :onConfigReady="onConfigReady" :queryHandler="queryHandler" :popupHandler="popupHandler"></swb-query-sort-area>
        </div>

        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="configAuto" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'

    import servcDelivApi from '../../api/servcDeliv'
    import servicerApi from '../../api/servicer'
    import servcCategApi from '../../api/servcCateg'

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    import SwbServcEvalInfo from './ServcEvalInfo';
    Vue.regist(SwbServcEvalInfo);
    import SwbServcCategTree from '../categ/ServcCategTree';
    Vue.regist(SwbServcCategTree);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';
    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-servc-eval-list',
        path: '/servc/eval/list',
        desc: '服务评价列表',
        notAsResc: true,
        customBreadcrumb: true,
        authen: false,
        data: function () {
            return {
                confKey: 'swb-servc-eval-list',
                configAuto: true,
                tableHeight: 300,
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 100,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                servcId: null,
                engineerId: null,
                workVoucherId: null,
                showBack: false,
                //
                comInfo: {},
                back: false,
                thisComId: null,
                thisComLevel: null,
                includeSubComs: false,
                initIncludeSubComs: false,
                showQuery: true,
            }
        },
        created: function () {
            // 服务列表跳转
            let servcId = this.$route.query.servcId || null;
            if(!Utils.isNoB(servcId)) {
                this.servcId = servcId;
                this.showBack = true;
                this.includeSubComs = true;
                this.initIncludeSubComs = true;
            }
            // 工程师列表跳转
            let engineerId = this.$route.query.engineerId || null;
            if(!Utils.isNoB(engineerId)) {
                this.engineerId = engineerId;
                this.showBack = true;
                this.includeSubComs = true;
                this.initIncludeSubComs = true;
            }
            // 派工单列表跳转
            let workVoucherId = this.$route.query.workVoucherId || null;
            if(!Utils.isNoB(workVoucherId)) {
                this.workVoucherId = workVoucherId;
                this.showBack = true;
                this.includeSubComs = true;
                this.initIncludeSubComs = true;
            }
            //
            this.pageSize = this.pageSizes.first();
            //
            this.getComDetail();
            this.getOrderServcEvalList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass("overflow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.tableHeight = height;
            });
            //domSizeWatcher.setHrEls();
            console.log("domHeight： " + self.domHeight);
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, [name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                self.getMerchtFusedServcCat(function (result) {
                    let dataList = result;
                    let query_model_ctrl = self.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo["catId"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                })
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);    // .getResultColConfRef()
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'attitudeScore': function (row, colName, colValue, rowIndex, colConf) {
                        let col = '';
                        for(let i = 0; i < row.attitudeScore; i++) {
                            col = col + '<span class="el-icon-star-on font-gold"></span> '
                        }
                        return col;
                    },
                    'skillsScore': function (row, colName, colValue, rowIndex, colConf) {
                        //
                        let col = '';
                        for(let i = 0; i < row.skillsScore; i++) {
                            col = col + '<span class="el-icon-star-on font-gold"></span> '
                        }
                        return col;
                    },
                    'qualityScore': function (row, colName, colValue, rowIndex, colConf) {
                        //
                        let col = '';
                        for(let i = 0; i < row.qualityScore; i++) {
                            col = col + '<span class="el-icon-star-on font-gold"></span> '
                        }
                        return col;
                    },
                    'avgScore': function (row, colName, colValue, rowIndex, colConf) {
                        //
                        let col = '';
                        for(let i = 0; i < row.avgScore; i++) {
                            col = col + '<span class="el-icon-star-on font-gold"></span> '
                        }
                        return col;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        //
                        return '<a name="show" class="swb-btn swb-btn-link">查看</a>';
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName === 'show') {
                            self.showEvalInfo(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            //
            getMerchtFusedServcCat: function (callBack) {
                servcCategApi.getMerchtFusedServcCatListByMerchantId({}, function (result) {
                    if(result.type == "info") {
                        let rows = result.data;
                        let catList = [{
                            value: null,
                            label: '- 全部 -'
                        }];
                        if(rows != null && rows.length > 0) {
                            rows.forEach(function (item) {
                                let cat = {};
                                cat.value = item.catId;
                                cat.label = item.catName;
                                catList.push(cat);
                            });
                        }
                        callBack(catList);
                    }
                })
            },
            notityChange: function (eventData) {
                if(eventData.id != this.thisComId || this.includeSubComs != eventData.includeSubComs) {
                    this.thisComLevel = eventData.level;
                    this.thisComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                    this.getComDetail();
                    this.getOrderServcEvalList();
                }
            },
            getComDetail: function () {
                let self = this;
                let postData = {
                    comId: this.thisComId
                };
                servicerApi.getServicerCom(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        self.comInfo = Utils.merge({}, data);
                        self.thisComLevel = data.level;
                        self.thisComId = data.id;
                        self.getOrderServcEvalList();
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },

            popupHandler(fieldCode, curValue, curText){
                let self = this;
                Vue.$showDialog({
                    title: '服务分类信息',
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-servc-categ-tree :noPostFilters="true" :isClickEvent="false" :enableSearch = "enableSearch" ref="swb_servc_categ_tree"></swb-servc-categ-tree>' +
                    '</div>',
                    data: {
                        enableSearch: true
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_servc_categ_tree.getDlgResult() || {};
                        // 成功执行
                        if(result != null && result.type === 'info') {
                            let cat = result.data;
                            let query_model_ctrl = self.$refs['query_model_ctrl'];
                            let fieldInfo = {};
                            fieldInfo["catId"] = {
                                value: cat.id,
                                text: cat.name
                            };
                            query_model_ctrl.updateFields(fieldInfo);
                            return true;
                        } else {
                            this.$message.error(result.message);
                        }
                        return false;
                    },
                });
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getOrderServcEvalList();
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getOrderServcEvalList();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getOrderServcEvalList();
            },
            getOrderServcEvalList: function () {
                let self = this;
                let postData = {};
                //
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.servicerShopId = this.thisComId;
                filterItems.comLevel = this.thisComLevel;
                filterItems.includeSubComs = this.includeSubComs;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                if(!Utils.isNoB(self.servcId)) {
                    postData.filterItems.servcId = self.servcId;
                }
                if(!Utils.isNoB(self.engineerId)) {
                    postData.filterItems.engineerId = self.engineerId;
                }
                if(!Utils.isNoB(self.workVoucherId)) {
                    postData.filterItems.workVoucherId = self.workVoucherId;
                }
                let theLoading = MsgBox.loading();
                servcDelivApi.getOrderServcEvalList(postData, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        let rows = result.data.rows;
                        rows.forEach(function (el) {
                            let totalScore = el.totalScore;
                            el.avgScore = Math.round(totalScore / 3);
                        });
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.renderTable(rows, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showEvalInfo: function (evalId) {
                let theDlg = Vue.$showDialog({
                    title: "评价详情",
                    showCloseBtn: true,
                    width: 800,
                    height: 700,
                    okText: "知道了",
                    cancelVisible: false,
                    template: '<div v-loading="loading" element-loading-text="保存中...">' +
                    '<swb-servc-eval-info :evalId="evalId" ref="swb_servc_eval_info"></swb-servc-eval-info>' +
                    '</div>',
                    data: {
                        loading: false,
                        evalId: null,
                    },
                    okClicked: function () {
                        theDlg.close();
                    },
                    methods: {},
                    lifecycle: {
                        created: function () {
                            this.evalId = evalId;
                        }
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcOrder/ServcEvalList.vue